import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { rejects } from 'assert';
import { resolve } from 'dns';
import * as firebase from 'firebase/compat/app';
import { firebaseUser } from '../interfaces/firebaseUser';
import { login_signup } from '../interfaces/login_signup';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  firebaseUser = {} as firebaseUser;

  constructor(private afAuth: AngularFireAuth, private router: Router) { }


  async loginWithGoogle():Promise<firebaseUser>{
    const res = await this.afAuth.signInWithPopup( new firebase.default.auth.GoogleAuthProvider());
   
    const user = res.user;
    this.firebaseUser.name = user.displayName;
    this.firebaseUser.email = user.email;
    this.firebaseUser.picture = user.photoURL;
    this.firebaseUser.uid = user.uid;
    

    this.saveUserTolocalDb(this.firebaseUser);
    
    return {...this.firebaseUser,isNew:res.additionalUserInfo.isNewUser};
    
  }

  async loginWithFacebook(){
    const res = await this.afAuth.signInWithPopup( new firebase.default.auth.FacebookAuthProvider());
    const user = res.user;
    this.firebaseUser.name = user.displayName;
    this.firebaseUser.email = user.email;
    this.firebaseUser.picture = user.photoURL;
    this.firebaseUser.uid = user.uid;

    this.saveUserTolocalDb(this.firebaseUser);
  }

  async loginWithEmailPaswword(userInfo: login_signup){

    const promise = new Promise((resolve,reject)=> {

      this.afAuth.signInWithEmailAndPassword(userInfo.email, userInfo.password).then(res => {
        const user = res.user;
        this.firebaseUser.name = user.displayName;
        this.firebaseUser.email = user.email;
        this.firebaseUser.picture = user.photoURL;
        this.firebaseUser.uid = user.uid;
        this.saveUserTolocalDb(this.firebaseUser);
        resolve(res);
      },err => {
        reject(err.message)
      }).catch(err => {
        reject(err.message);
      });
    })

    return promise

   
  }

  async signUpWithEmailPassword(userInfo: login_signup){
    
    
    const promise = new Promise((resolve,reject)=> {
    
    this.afAuth.createUserWithEmailAndPassword(userInfo.email, userInfo.password).then(res => {
      const user = res.user;
      this.firebaseUser.name = user.displayName;
      this.firebaseUser.email = user.email;
      this.firebaseUser.picture = user.photoURL;
      this.firebaseUser.uid = user.uid;
      this.saveUserTolocalDb(this.firebaseUser);
      resolve(res);
    },err => {
      reject(err.message)
    }).catch(err => {
      reject(err.message);
    });
  })

  return promise
  }

  signOut(){
    this.afAuth.signOut().then(val => {
 
      console.log(val);
      firebase.default.auth().signOut();
      localStorage.clear();
      this.router.navigateByUrl('/landing');
    })
  }

  getCurrentUser(){
    this.afAuth.onAuthStateChanged(user => {
    
      if(user){

      }
    })

    
  }


  getUserFromLocalDb(): firebaseUser{
     var user = JSON.parse(localStorage.getItem('currentUser'));
     return user
  }


  saveUserTolocalDb(userInfo:firebaseUser){

    var userToSave = JSON.stringify(userInfo); 

    localStorage.setItem('currentUser',userToSave)

    console.log('User saved');
  }

  removeUserFromLocalDb(){
    localStorage.removeItem('currentUser');
  }

}
